export default __webpack_public_path__ + "static/media/FutuBk.9cafd519.ttf";